module.exports = __webpack_public_path__ + "static/img/female-bg-fr.1d3def94.png";